{
    "welcome": "Benvenuto",
    "getStarted": "Inizia"
}
